import { useState, useEffect, useCallback } from 'react';
import { useMountedState } from 'react-use';

import { IRequirementsTemplate } from 'APIPackage/AccountModule/interfaces/IRequirementsTemplate';
import { fetchRequirementTemplate } from 'APIPackage/AccountModule/services/requirementTemplatesApi';

export function useRequirementTemplate(templateId?: number) {
  const isMounted = useMountedState();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [requirementTemplate, setRequirementTemplate] = useState<IRequirementsTemplate>();

  const getRequirementTemplate = useCallback(
    async (id: number) => {
      try {
        setIsLoading(true);
        setIsSuccess(false);
        const response = await fetchRequirementTemplate(id);

        if (isMounted()) {
          setRequirementTemplate(response);
          setIsSuccess(true);
        }

        return {
          success: true,
          data: response,
        };
      } catch (err) {
        return {
          success: false,
        };
      } finally {
        isMounted() && setIsLoading(false);
      }
    },
    [isMounted],
  );

  useEffect(() => {
    if (templateId) {
      getRequirementTemplate(templateId);
    }
  }, [templateId, getRequirementTemplate]);

  return {
    isLoading,
    isSuccess,
    getRequirementTemplate,
    requirementTemplate,
  };
}
